import React, { Component } from 'react';
import { BrowserRouter, Switch, Route, Link } from 'react-router-dom';
import './App.css';
import Home from './Home/Home';
import About from './About/About';
import Projects from './Projects/Projects';
import Courses from './Courses/Courses';
import Contact from './Contact/Contact';
import Resume from './assets/img/Andy.pdf';

export default class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      homeHeight: 0,
      aboutHeight: 0,
      projectsHeight: 0,
      coursesHeight: 0,
      contactHeight: 0,
      headerBackground: false,
      height: 0,
    }
    
    this.homeHeightUpdate = this.homeHeightUpdate.bind(this);
    this.aboutHeightUpdate = this.aboutHeightUpdate.bind(this);
    this.projectsHeightUpdate = this.projectsHeightUpdate.bind(this);
    this.coursesHeightUpdate = this.coursesHeightUpdate.bind(this);
    this.contactHeightUpdate = this.contactHeightUpdate.bind(this);
    this.homeClick = this.homeClick.bind(this);
    this.aboutClick = this.aboutClick.bind(this);
    this.projectsClick = this.projectsClick.bind(this);
    this.coursesClick = this.coursesClick.bind(this);
    this.contactClick = this.contactClick.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll(event) {
    this.setState({
      height: window.pageYOffset,
    });
    if(window.pageYOffset >= 50){
      this.setState({
        headerBackground: true,
      });
    } else {
      this.setState({
        headerBackground: false,
      });
    }
  }

  homeHeightUpdate(height) {
    this.setState({ homeHeight: height });
  }
  aboutHeightUpdate(height) {
    this.setState({ aboutHeight: height });
  }
  projectsHeightUpdate(height) {
    this.setState({ projectsHeight: height });
  }
  coursesHeightUpdate(height) {
    this.setState({ coursesHeight: height });
  }
  contactHeightUpdate(height) {
    this.setState({ contactHeight: height });
  }
  homeClick(event) {
    event.preventDefault();
    window.scrollTo({top: 0, behavior: 'smooth'})
  }
  aboutClick(event) {
    event.preventDefault();
    window.scrollTo({top: this.state.homeHeight, behavior: 'smooth'});
  }
  projectsClick(event) {
    event.preventDefault();
    window.scrollTo({top: this.state.homeHeight + this.state.aboutHeight, behavior: 'smooth'});
  }
  coursesClick(event) {
    event.preventDefault();
    window.scrollTo({top: this.state.homeHeight + this.state.aboutHeight + this.state.projectsHeight, behavior: 'smooth'});
  }
  contactClick(event) {
    event.preventDefault();
    window.scrollTo({top: this.state.homeHeight + this.state.aboutHeight + this.state.projectsHeight + this.state.coursesHeight, behavior: 'smooth'});
  }

  render() {
    return (
      <BrowserRouter>
        <Switch>
          {/* <Route exact path="/credit-visualization" render={() => {window.location.href='credit-visualization/index.html'}} /> */}
          {/* <Route exact path="/credit-visualization" render={CreditVisualization} /> */}
          <Route exact path="/">
            {<div className="App" onScroll={this.handleScroll}>
              <Header 
                homeClick = {this.homeClick}
                aboutClick = {this.aboutClick}
                projectsClick = {this.projectsClick}
                coursesClick = {this.coursesClick}
                contactClick = {this.contactClick}
                headerBackground = {this.state.headerBackground}
                height = {this.state.height}
              />
              <Home heightUpdate={this.homeHeightUpdate}/>
              <About heightUpdate={this.aboutHeightUpdate}/>
              <Projects heightUpdate={this.projectsHeightUpdate}/>
              <Courses heightUpdate={this.coursesHeightUpdate}/>
              <Contact heightUpdate={this.contactHeightUpdate}/>
              {this.state.headerBackground && <div className="return-top fas fa-angle-up" onClick={this.homeClick}></div>}
            </div>}
          </Route>
        </Switch>
      </BrowserRouter>
    );
  }
}

class Header extends Component {

  render() {
    return(      
      <div id="header" className={"header"}>
        <ul className={"header-list "  + (this.props.headerBackground ? 'header-background-pin' : 'header-background-unpin')}>
          <div className='header-name-logo'>
            <h2 onClick={this.props.homeClick} className={(this.props.headerBackground ? 'header-name-logo-pin' : 'header-name-logo-unpin')}>A L </h2>
          </div>
          <div className="list-container">
            {/* <li className="header-home">
              <button className="header-button" onClick={this.props.homeClick}>Home</button>
            </li> */}
            <li className="header-about">
              <button className="header-button" onClick={this.props.aboutClick}>About</button>
            </li>
            <li className="header-projects">
              <button className="header-button" onClick={this.props.projectsClick}>Projects</button>
            </li>
            <li className="header-courses">
              <button className="header-button" onClick={this.props.coursesClick}>Courses</button>
            </li>
            <li className="header-contact">
              <button className="header-button" onClick={this.props.contactClick}>Contact</button>
            </li>
            <li className='header-links'>
              <a href={Resume} target='_blank' rel="noopener noreferrer"><span className="far fa-file-alt"></span></a>
              <a href='https://github.com/aliang6/' target='_blank' rel="noopener noreferrer"><span className="fab fa-github"></span></a>
              <a href='https://www.linkedin.com/in/andy-liang-677167127/' target='_blank' rel="noopener noreferrer"><span className="fab fa-linkedin-in"></span></a>
            </li>
          </div>
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js